var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsOptional, IsString, ValidateNested } from "class-validator";
export class IdpIssuerProbeCheckDto {
}
__decorate([
    IsString()
], IdpIssuerProbeCheckDto.prototype, "id", void 0);
__decorate([
    IsString()
], IdpIssuerProbeCheckDto.prototype, "label", void 0);
__decorate([
    IsBoolean()
], IdpIssuerProbeCheckDto.prototype, "passed", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], IdpIssuerProbeCheckDto.prototype, "warning", void 0);
__decorate([
    IsString()
], IdpIssuerProbeCheckDto.prototype, "detail", void 0);
export class IdpIssuerProbeResultDto {
}
__decorate([
    IsString()
], IdpIssuerProbeResultDto.prototype, "issuer", void 0);
__decorate([
    IsBoolean()
], IdpIssuerProbeResultDto.prototype, "ok", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => IdpIssuerProbeCheckDto)
], IdpIssuerProbeResultDto.prototype, "checks", void 0);
__decorate([
    IsArray(),
    IsString({ each: true })
], IdpIssuerProbeResultDto.prototype, "supportedClientAuthMethods", void 0);
export class IdpIssuerProbeInput {
}
__decorate([
    IsString()
], IdpIssuerProbeInput.prototype, "issuer", void 0);
export class VerifiedIdpIssuerDto {
}
__decorate([
    IsString()
], VerifiedIdpIssuerDto.prototype, "issuer", void 0);
__decorate([
    IsString()
], VerifiedIdpIssuerDto.prototype, "checkedAt", void 0);
__decorate([
    IsBoolean()
], VerifiedIdpIssuerDto.prototype, "ok", void 0);
__decorate([
    IsArray(),
    IsString({ each: true })
], VerifiedIdpIssuerDto.prototype, "supportedClientAuthMethods", void 0);
